import React from 'react';
import { Modal } from './Modal';
interface PrivacyModalProps {
  onClose: () => void;
}
export const PrivacyModal: React.FC<PrivacyModalProps> = ({
  onClose
}) => {
  return <Modal title="Política de Privacidad" onClose={onClose} data-id="element-268">
      <div className="space-y-4 text-gray-700" data-id="element-269">
        <h3 className="text-lg font-semibold text-gray-900" data-id="element-270">
          1. Recopilación de Información
        </h3>
        <p data-id="element-271">
          Recopilamos información personal como nombre, dirección de correo
          electrónico y detalles de pago cuando realizas una compra. Esta
          información se utiliza para procesar tu pedido y proporcionarte el
          producto digital.
        </p>
        <h3 className="text-lg font-semibold text-gray-900" data-id="element-272">
          2. Uso de la Información
        </h3>
        <p data-id="element-273">La información recopilada se utiliza para:</p>
        <ul className="list-disc pl-6 space-y-2" data-id="element-274">
          <li data-id="element-275">Procesar y completar tu compra</li>
          <li data-id="element-276">Enviarte el Recetario Fit para Airfryer</li>
          <li data-id="element-277">Comunicarnos contigo sobre tu compra</li>
          <li data-id="element-278">
            Proporcionarte actualizaciones o información adicional relacionada
            con el producto
          </li>
          <li data-id="element-279">Mejorar nuestros productos y servicios</li>
        </ul>
        <h3 className="text-lg font-semibold text-gray-900" data-id="element-280">
          3. Protección de la Información
        </h3>
        <p data-id="element-281">
          Implementamos medidas de seguridad diseñadas para proteger tu
          información personal. Sin embargo, ningún método de transmisión por
          Internet o almacenamiento electrónico es 100% seguro, por lo que no
          podemos garantizar su seguridad absoluta.
        </p>
        <h3 className="text-lg font-semibold text-gray-900" data-id="element-282">
          4. Compartir Información
        </h3>
        <p data-id="element-283">
          No vendemos, intercambiamos ni transferimos tu información personal a
          terceros sin tu consentimiento, excepto cuando sea necesario para
          completar tu compra (como procesadores de pago) o cuando sea requerido
          por la ley.
        </p>
        <h3 className="text-lg font-semibold text-gray-900" data-id="element-284">5. Cookies</h3>
        <p data-id="element-285">
          Utilizamos cookies para mejorar tu experiencia en nuestro sitio web.
          Puedes configurar tu navegador para rechazar todas las cookies o para
          indicar cuándo se envía una cookie. Sin embargo, si no aceptas
          cookies, es posible que algunas partes de nuestro sitio no funcionen
          correctamente.
        </p>
        <h3 className="text-lg font-semibold text-gray-900" data-id="element-286">6. Tus Derechos</h3>
        <p data-id="element-287">
          Tienes derecho a acceder, corregir o eliminar tu información personal.
          Si deseas ejercer estos derechos, contáctanos a través de los canales
          proporcionados.
        </p>
      </div>
    </Modal>;
};